import service from '../service'
import store from '../../store'

export function getDrawDepositList(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/queryDrawMoneyList', params)
}

export function saveWithdrawMoney(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitOrderLoanApply', params)
}

export function getSurplusInfo(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/queryMessageServiceMoney', params)
}

// 结算主体列表
export function getConsignorSub() {
	return service.post('/oms-consignor-pc/settle/apply/consignor/queryConsignorSub')
}

// 提款前查询资金方和提示信息
export function queryCapitalTypeAndMessage(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/queryCapitalTypeAndMessage', params)
}

// 京东数科提交申请
export function submitJDOrderLoanApply(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitJDOrderLoanApply', params)
}

// 申请提款 导出
export function exportDrawMoneyListData(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/exportDrawMoneyListData', params)
}

// 申请提款 导出列表
export function queryDrawMoneyFilesList(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/queryDrawMoneyFilesList', params)
}

// 发起签署
export function submitSignatureContract(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitSignatureContract', params)
}
// export default {
//   getDrawDepositList(params) {
//     return service.post('/drawMoney/consignor/queryConsignorOrderReportResult', params);
//   },
//   // 申请提款
//   drawDepositApply(params) {
//       return service.post('/oms-consignor-pc/deposit/consignor/depositApply', params)
//   },
//   // 获取余额
//   getSurplusInfo(params) {
//     return service.post('/oms-consignor-pc/productionCapacity/queryProductionCapacityListPage', params);
//   },
// }

// 交行
export function submitJTOrderLoanApply(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitJTOrderLoanApply', params)
}

// 华瑞
export function submitHROrderLoanApply(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitHROrderLoanApply', params)
}
// 浙商银行
export function submitZSOrderLoanApply(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitZSOrderLoanApply', params)
}
// 华夏银行
export function submitHXOrderLoanApply(params) {
	return service.post('/oms-consignor-pc/drawMoney/consignor/submitHXOrderLoanApply', params)
}
//临时token
export function getTempToken(params) {
	return service.post('/whale-pc/pcLogin/getTempToken', params)
}

